import React from 'react';
import ReactPlayer from 'react-player';

interface Props {
  header: string;
  description: string | React.ReactNode;
  image?: string;
  videoUrl?: string;
  isVideo?: boolean;
  onProgress?: (progress: { played: number; playedSeconds: number; loaded: number; loadedSeconds: number }) => void;
}

const OnboardingModalBody = ({ header, description, image, videoUrl, isVideo = false, onProgress }: Props) => {
  const handleProgress = (state: { played: number; playedSeconds: number; loaded: number; loadedSeconds: number }) => {
    onProgress?.(state);
  };

  return (
    <div className="mt-4 mb-6">
      <h3 className="onboarding-modal-header">{header}</h3>
      <p className="text-base font-normal text-subdued text-center mb-4 mx-4">{description}</p>
      {isVideo && videoUrl ? (
        <div className="onboarding-modal-video">
          <ReactPlayer
            url={videoUrl}
            width="100%"
            height="408px"
            controls={true}
            light={image}
            onProgress={handleProgress}
          />
        </div>
      ) : (
        <img className="onboarding-modal-image" src={image} alt="image" />
      )}
    </div>
  );
};

export default OnboardingModalBody;
